<div class="map-container">
  <div
    *ngIf="innercenter"
    style="height: 100%"
    leaflet
    [leafletOptions]="this.options"
    [leafletLayers]="this.markers"
    [(leafletCenter)]="this.innercenter"
    [(leafletZoom)]="this.innerzoom"
    (leafletClick)="onClick($event)"
  >
    <div
      *ngIf="_candraw"
      leafletDraw
      [leafletDrawOptions]="drawOptions"
      (leafletDrawCreated)="onDrawCreated($event)"
      (leafletDrawDeleted)="onDrawDelete($event)"
      (leafletDrawStart)="onDrawStarted($event)"
    ></div>
  </div>
</div>
